import { render, staticRenderFns } from "./customerChurnDetail.vue?vue&type=template&id=47fec41b&scoped=true&"
import script from "./customerChurnDetail.vue?vue&type=script&lang=js&"
export * from "./customerChurnDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerChurnDetail.vue?vue&type=style&index=0&id=47fec41b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fec41b",
  null
  
)

export default component.exports